import styled from 'styled-components'
// components
import { Scrollbar } from 'components/UI'
// views
import { Paper as PaperOrigin } from 'components/Modals/PlanItems/KPI/MinimizedModal/components/DetailsSection/components/DetailsForm/components/view'

export const Paper = styled((props) => <PaperOrigin {...props} />)`
  && {
    height: calc(100vh - 200px);

    ${Scrollbar} {
      height: calc(100% - 120px);
      margin-right: -15px;
      padding: 0 24px 0 4px;
    }

    hr {
      margin-bottom: 10px;
    }
  }
`

export const ButtonsWrapper = styled('div')`
  margin-top: 8px;

  div:first-child {
    margin-right: 16px;
  }
`
